import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { ButtonSmall } from 'react-wot-bootstrap'

import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'
import { toCssClass, toRoman } from 'helpers'
import { KEY_CODES } from 'constants'
import { CANCEL } from 'helpers/i18n'

import {
    UPGRADE_CONFIRMATION_MESSAGE,
    UPGRADE_CONFIRMATION_LEVEL,
    UPGRADE_CONFIRMATION_SUBMIT,
    RADIANCE_LAYERS_COUNT,
} from './constants.jsx'

import styles from './UpgradeConfirmationView.scss'

export class UpgradeConfirmationView extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        name: PropTypes.node.isRequired,
        level: PropTypes.number.isRequired,
        upgraded: PropTypes.bool.isRequired,
        upgradeCost: PropTypes.number.isRequired,
        submitHandler: PropTypes.func.isRequired,
        cancelHandler: PropTypes.func.isRequired,
    }

    constructor() {
        super()
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.onKeyUp = this.onKeyUp.bind(this)
    }
    componentWillMount() {
        window.addEventListener('keydown', this.onKeyUp)

        // this component do the animation and during the animation
        // props might have been changed and incorrect level will be shown
        this.setState({
            levelBeforeUpgrade: this.props.level,
            upgradeCostBeforeUpgrade: this.props.upgradeCost,
        })
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyUp)
    }
    onKeyUp(e) {
        if (e.keyCode === KEY_CODES.ESCAPE) {
            this.handleCancel()
        }
        if (e.keyCode === KEY_CODES.ENTER) {
            this.handleSubmit()
        }
    }
    handleSubmit() {
        this.props.submitHandler()
    }

    handleCancel() {
        this.props.cancelHandler()
    }

    render() {
        const { type, name, level } = this.props
        const nextLevel = this.state.levelBeforeUpgrade + 1

        const radianceLayers = Array.from({ length: RADIANCE_LAYERS_COUNT }, (item, index) => {
            const layerClass = classNames(styles.radianceLayer, styles[`radianceLayer__${index}`])
            return (
                <div className={layerClass} key={`radianceLayer_${index}`}></div>
            )
        })

        const levelComponent = (
            <span className={styles.level}>
                {toRoman(nextLevel)}
                <span className={styles.levelGradient}>{toRoman(nextLevel)}</span>
            </span>
        )

        const levelSubstringComponent = (
            <span className={styles.levelSubstring}>
                {UPGRADE_CONFIRMATION_LEVEL}
                <span className={styles.levelSubstringGradient}>{UPGRADE_CONFIRMATION_LEVEL}</span>
            </span>
        )

        const inlineNameComponent = (
            <span className={styles.inlineName}>{name}</span>
        )

        const inlineLevelComponent = (
            <span className={styles.inlineLevel}>
                {toRoman(nextLevel)}
                <span className={styles.inlineLevelGradient}>{toRoman(nextLevel)}</span>
            </span>
        )

        const imageLevel = this.props.upgraded ? nextLevel : level
        const imageClassName = classNames(
            styles.image,
            styles[`image__${toCssClass(type)}`],
            styles[`image__level-${imageLevel}`],
        )

        const className = classNames(styles.base, {
            [styles.base__animateUpgrading]: this.props.upgraded,
        })

        return (
            <div className={className}>
                <div className={styles.building}>
                    <div className={imageClassName}></div>

                    <div className={styles.levelHolder}>
                        {levelComponent}
                        {levelSubstringComponent}
                    </div>

                    <div className={styles.radiance}>
                        {radianceLayers}
                    </div>
                </div>
                <div className={styles.footer}>
                    <p className={styles.message}>
                        {UPGRADE_CONFIRMATION_MESSAGE(
                            inlineNameComponent,
                            inlineLevelComponent,
                            <IndustrialResource value={this.state.upgradeCostBeforeUpgrade} small/>
                        )}
                    </p>
                    <div className={styles.button}>
                        <ButtonSmall onClick={this.handleSubmit}>
                            {UPGRADE_CONFIRMATION_SUBMIT}
                        </ButtonSmall>
                    </div>
                    <div className={styles.button}>
                        <ButtonSmall
                            onClick={this.handleCancel}
                            type='secondary'
                            isCancel
                        >
                            {CANCEL}
                        </ButtonSmall>
                    </div>
                </div>
            </div>
        )
    }
}

export default UpgradeConfirmationView



// WEBPACK FOOTER //
// ./components/UpgradeConfirmationView/UpgradeConfirmationView.jsx